interface Tag {
  id?: number;
  name?: string;
  companyId?: number;
}

export const newTag = (): Tag => {
  return {};
};

export default Tag;
